/**
 * Добавит ед./изм. value + px, если передан number
 */
export var toCssSize = function toCssSize(value) {
  return typeof value === 'number' ? "".concat(value, "px") : value;
};